import { Component, Input, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export enum BulkAction {
    UNCHANGED = 'unchanged',
    MODIFY = 'modify',
    REMOVE = 'remove',
    ADD = 'add'
}

export interface BulkEditToggleOption {
    label: string;
    value: BulkAction;
}

@Component({
    selector: 'syn-bulk-edit-toggle',
    templateUrl: './bulk-edit-toggle.component.html',
    styleUrls: ['./bulk-edit-toggle.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BulkEditToggleComponent),
            multi: true
        }
    ]
})
export class BulkEditToggleComponent implements ControlValueAccessor {

    @Input() unchangedValue = BulkAction.UNCHANGED;

    @Input() options: BulkEditToggleOption[] = [
        { label: 'Modifier', value: BulkAction.MODIFY },
        { label: 'Retirer', value: BulkAction.REMOVE }
    ];

    value: string = this.unchangedValue;
    disabled = false;

    writeValue(value: string): void {
        this.value = value || this.unchangedValue;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onValueChange(value: string): void {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }

    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};
}
